<template>
	<div>
		<user-nav-menu
			bg-color="transparent"
			text-color="#ffffff"
			:disable-edit-profile="true"
			user-type="LOCUM"
			:disable-account="true"
			:logo-file-name="tenant.settings.brandImages.headerLogos.app.light"
		></user-nav-menu>
		<v-row align="center" justify="center">
			<v-col cols="11" md="7" sm="7">
				<v-overlay :value="spinning"><v-progress-circular :indeterminate="true"></v-progress-circular></v-overlay>
				<h1 class="create-profile-title justify-center text-center pb-5 pt-5">Complete your profile</h1>
				<!-- <notification v-show="showNotification"></notification> -->
				<progressbar v-show="!showNotification"></progressbar>
				<v-card class="card-rounded elevation-1 mt-3" style="width: 100%; height: auto">
					<v-card-title class="pb-0 pl-1">
						<v-btn
							v-show="context != 'complete-profile-steps' && context != previous_context && previous_context != null"
							text
							color="secondary"
							style="font-family: Montserrat; font-style: normal; font-weight: bold"
							@click="goBack"
							><v-icon left color="secondary">keyboard_arrow_left</v-icon>Back</v-btn
						>
					</v-card-title>

					<component :is="context ? context : 'v-card'" :required_forms="required_forms" :booster_forms="booster_forms"></component>

					<v-card-actions align="center" justify="center" class="justify-center text-center">
						<v-container>
							<v-row align="center" justify="center">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										:v-show="show_button"
										:loading="spinning"
										large
										class="text-none button-rounded continue-signup-button"
										style="text-transform: none !important"
										:height="54"
										:color="button_color"
										@click="SubmitForm()"
										>{{ button_text }}<v-icon>arrow_forward</v-icon></v-btn
									>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" sm="12" md="12">
									<v-btn
										v-show="showSkip"
										class="pt-0 mt-0"
										text
										link
										color="primary"
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: normal;
											font-size: 11px;
											line-height: 17px;
											text-align: right;
											text-decoration-line: underline;
										"
										@click="$router.push('/')"
									>
										I’ll do this later, skip to dashboard
									</v-btn>
									<v-card-text v-show="!showSkip && this.context == 'complete-profile-steps'">
										Complete the required steps to proceed to your dashboard.
									</v-card-text>
								</v-col>
							</v-row>
						</v-container>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { bus } from '@/main';
// import { Auth } from 'aws-amplify'
// import axios from 'axios';
import store from '@/store';

import CompleteProfileSteps from '@/components/locum/profile/CompleteProfileStepsForm.vue';
import progressbar from '@/components/locum/complete profile steps/progressbar.vue';
import notification from '@/components/locum/complete profile steps/notification.vue';

import educationStep from '@/components/locum/complete profile steps/Education.vue';
import bankingStep from '@/components/locum/complete profile steps/PaymentDetails.vue';
import uploadIdStep from '@/components/locum/complete profile steps/UploadID.vue';
import ratesStep from '@/components/locum/complete profile steps/Rates.vue';
import experienceStep from '@/components/locum/complete profile steps/Experience.vue';
import locationsStep from '@/components/locum/complete profile steps/Locations.vue';
import AboutStep from '../components/locum/complete profile steps/About.vue';
import completedStep from '../components/locum/complete profile steps/CompletedStep.vue';

// import calendarStep from '../components/locum/complete profile steps/CalendarStep.vue';
import UserNavMenu from '@/components/user/UserNavMenu';
import { Tracking } from '@/utils';

export default {
	components: {
		CompleteProfileSteps,
		progressbar,
		notification,

		educationStep,
		bankingStep,
		uploadIdStep,
		ratesStep,
		experienceStep,
		locationsStep,
		AboutStep,
		UserNavMenu,

		// calendarStep,

		completedStep,
	},
	data: () => ({
		topcard: 'progressbar',
		showNotification: false,
		// button_text : "None",
		// button_color : "primary",
		button_state: false,
		show_button: true,
		spinning: false,
		button_loading: false,
		previous_context: null,
	}),
	computed: {
		user: () => store.getters.user,
		required_forms: () => store.getters.stepsRequired,
		booster_forms: () => store.getters.stepsBoosted,
		context: () => store.getters.currentStep,
		next_booster_step: () => store.getters.getNextBoosterSignupStep,
		next_step: () => store.getters.getNextSignupStep,
		showSkip: function () {
			return store.getters.getNextSignupStep === false && store.getters.getIsApproved;
		},
		next_step_context: function () {
			//get the next step to move to.
			//will select the next required step, then next booster step, else both are false and
			//if there is no next step from the store then use 'completed-step'
			const next_step = this.next_step;
			const next_step_booster = this.next_booster_step;
			if (next_step != false) {
				if (next_step_booster == false && this.context != next_step.context) {
					return next_step.context;
				} else {
					return next_step.context;
				}
			} else if (next_step == false && next_step_booster != false && this.context != next_step_booster.context) {
				return next_step_booster.context;
			} else if (next_step == false && next_step_booster == false) {
				return 'completed-step';
			} else {
				alert(
					'unknown ' +
						(next_step != false ? next_step.context : 'no next_step') +
						'| ' +
						(next_step_booster != false ? next_step_booster.context : 'no next_step_booster') +
						'| current :' +
						this.context
				);
				return false;
			}
		},
		button_text: function () {
			//get the buttons text to use.
			//first fetch the text from the required step, else fetch booster step.
			//if not step and all steps completed BUT NOT on the completed-step step, then display "Unlock Star Profile" text,
			//ELSE if all steps completed and on comepleted step - display "Find Offers" text
			const next_step = this.next_step;
			const next_step_booster = this.next_booster_step;
			if (next_step != false) {
				if (next_step_booster == false && this.context != next_step.context) {
					// alert("something broke. please contact an admin. error code - SC01");
					return 'Continue to ' + next_step.button_text;
				} else {
					return 'Continue to ' + next_step.button_text;
				}
			} else if (next_step == false && next_step_booster != false && this.context != next_step_booster.context) {
				return 'Continue to ' + next_step_booster.button_text;
			} else if (next_step == false && next_step_booster == false) {
				if (this.context == 'completed-step') {
					return this.getLabel('locumCompleteProfileCompleteButton', 'Find Offers');
				} else {
					return this.getLabel('locumProfileUnlockButton', 'Unlock Your Star Profile');
				}
			} else {
				alert('something broke. please contact an admin. error code - UNK01');
				return (
					'unknown ' +
					(next_step != false ? next_step.context : 'no next_step') +
					'| ' +
					(next_step_booster != false ? next_step_booster.context : 'no next_step_booster') +
					'| current :' +
					this.context
				);
			}
		},
		button_color: function () {
			//button color is orange for all cases except where there is no next step or booster and not on completed-step step
			const next_step = this.next_step;
			const next_step_booster = this.next_booster_step;
			if (next_step != false) {
				if (next_step_booster == false && this.context != next_step.context) {
					return 'primary';
				} else {
					return 'primary';
				}
			} else if (next_step == false && next_step_booster != false && this.context != next_step_booster.context) {
				return 'primary';
			} else if (next_step == false && next_step_booster == false) {
				if (this.context == 'completed-step') {
					return 'primary';
				} else {
					return '#63C367';
				}
			} else {
				return '#F21';
			}
		},
	},

	async mounted() {
		bus.$on('intent:previous-context', () => {
			store.commit('SET_STEP', this.previous_context);
			bus.$emit('steps@refresh');
		});
		bus.$on('intent:change-context', new_context => {
			this.previous_context = this.context;
			store.commit('SET_STEP', new_context); //commit the new context to store.
			bus.$emit('steps@refresh'); //request all steps to duck test and refresh
		});

		bus.$on('update:spinning', value => {
			this.spinning = value;
		});

		bus.$on('update:topcard', topcard => {
			this.topcard = topcard == 'progressbar' || topcard == 'notification' ? topcard : 'progressbar';
		});

		bus.$on('push:notification@hide', () => {
			this.showNotification = false; //hide it.
		});

		bus.$on('push:notification@show', () => {
			this.showNotification = true; //show it.
		});

		bus.$on('steps@refresh', async () => {
			await this.Update();
		});

		bus.$on('intent:next-step', requestee => {
			if (this.context == requestee) {
				this.NextStepRequested();
			} else {
				console.error(['request for context change by non owner form', requestee, this.context]);
			}
		});
		bus.$on('update:next-button-text', text => {
			this.UpdateSubmitButtonText(text);
		});
		bus.$on('update:next-button-color', color => {
			this.UpdateSubmitButtonColor(color);
		});
		bus.$on('update:next-button-enable', state => {
			this.UpdateSubmitButtonState(state);
		});
		bus.$on('update:next-button-loading', state => {
			this.UpdateSubmitButtonLoading(state);
		});

		store.commit('SET_LEVELS', {
			1: {
				top: this.getLabel('locumLevel1Top', 'You are not yet visible to practices'),
				bottom: this.getLabel('locumLevel1Bottom', 'Unlock profile, your professional information will be verified soon'),
			},
			2: {
				top: this.getLabel('locumLevel2Top', 'Keep going to view and accept offers online'),
				bottom: this.getLabel('locumLevel2Bottom', 'Complete your profile to increase visibility'),
			},
		});

		bus.$emit('steps@refresh');
	},

	created() {},
	beforeDestroy() {
		bus.$off('intent:previous-context');
		bus.$off('intent:change-context');

		bus.$off('update:spinning');

		bus.$off('update:topcard');

		bus.$off('push:notification@hide');

		bus.$off('push:notification@show');

		bus.$off('steps@refresh');

		bus.$off('intent:next-step');

		bus.$off('update:next-button-text');

		bus.$off('update:next-button-color');

		bus.$off('update:next-button-enable');
	},

	methods: {
		goBack() {
			bus.$emit('intent:previous-context');
		},
		SubmitForm() {
			bus.$emit('intent:submit-forms'); //submit the form, the form is expected to fire the 'next-step' intent when done.
			let Current_step = this.context;
			Tracking.track('Locum_SignUp_Next_Step', { Current_step });
		},
		UpdateSubmitButtonText(text) {
			this.button_text = text;
		},
		UpdateSubmitButtonColor(color) {
			this.button_color = color;
		},
		UpdateSubmitButtonState(state) {
			this.button_state = state;
		},
		UpdateSubmitButtonLoading(state) {
			this.button_loading = state;
		},

		async NextStepRequested() {
			store.commit('SET_STEP', this.next_step_context);
			bus.$emit('steps@refresh');
		},

		async Update() {
			await store.dispatch('UPDATE_NEXT_SIGNUP_STEP');

			let locumApproved = true;

			if (locumApproved === false) {
				bus.$emit('push:notification@update', {
					title: 'Account created!',
					subtitle: 'We’re busy verifying your information. In the meanwhile please complete your profile so we can start matching you to great offers.',
					avatar: true,
				});
				bus.$emit('push:notification@show');
			} else {
				bus.$emit('push:notification@hide');
			}
			let next_step = store.getters.getNextSignupStep; //performs check on all
			let next_booster_step = store.getters.getNextBoosterSignupStep; //performs check on all

			if (next_step != false && store.getters.currentStep != next_step.context) {
				//we do have a next step
			} else if (next_step == false && store.getters.currentStep == 'complete-profile-steps' && next_booster_step == false) {
				bus.$emit('push:notification@update', {
					title: 'Congrats! You’re profile is live.',
					subtitle: 'You’re now visible to practices and will soon be receiveing offers. Complete your profile to get more visibility and better offer matched. ',
					avatar: true,
				});
				bus.$emit('push:notification@show');
			}
		},
	},
};
</script>
